import axios from "axios";
import { EmployeeF1Request } from "../schemas/f1Connect.shema";

export function putInsertOrUpdateF1Wrapper(body: EmployeeF1Request) {
    return axios.put<string>('/v1/f1/employee/update', body, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('SSO_AUTH')
        }
    });
}